export default {
  state: {
    show: false,
    type: null,
  },
  getters: {
    getShow: state => state.show,
    getType: state => state.type,
  },
  mutations: {
    showHelp: (state, type) => {
      state.type = type;
      state.show = true;
    },
    hideHelp: state => {
      state.show = false;
      state.type = null;
    },
  },
  actions: {
    showHelp({ commit }, type) {
      commit('showHelp', type);
    },
    hideHelp({ commit }) {
      commit('hideHelp');
    },
  },
};
